import { Injectable } from '@angular/core';
import { MessageService } from '@progress/kendo-angular-l10n';
import { TranslateService } from '@ngx-translate/core';
import { ContextService } from '@maximizer/core/shared/data-access';
import { KendoTranslations } from '../models/kendo-component';
import { Translation } from '@maximizer/core/shared/domain';

@Injectable()
export class KendoMessageService extends MessageService {
  private readonly noDataTranslation: Translation= {
    resourceID: 'JSS_GenTextNoDataFound',
    translationID: 'texts.noData',
  }
  private readonly todayTranslation: Translation= {
    resourceID: 'JSS_GenTxtToday',
    translationID: 'dates.today',
  }
  private readonly messages: KendoTranslations = {
    'kendo.autocomplete.noDataText': this.noDataTranslation,
    'kendo.dropdownlist.noDataText': this.noDataTranslation,
    'kendo.combobox.noDataText': this.noDataTranslation,
    'kendo.multiselect.noDataText': this.noDataTranslation,
    'kendo.multiselecttree.noDataText': this.noDataTranslation,
    'kendo.multicolumncombobox.noDataText': this.noDataTranslation,
    'kendo.dropdowntree.noDataText': this.noDataTranslation,
    'kendo.datepicker.today': this.todayTranslation,
  };

  constructor(
    private readonly context: ContextService,
    private readonly translate: TranslateService,
  ) {
    super();
  }

  public override get(key: string): string | undefined{
    const translation = this.messages[key];
    if (!translation) {
      return undefined;
    }

    if (
      translation.resourceID &&
      this.context.resources?.[translation.resourceID]
    ) {
      return this.context.resources[translation.resourceID];
    }

    if (translation.translationID) {
      return this.translate.instant(translation.translationID);
    }

    return undefined;
  }
}
